module.exports = __webpack_public_path__ + "media/images/page/estate_properties/img_01-d9ea36ffc7c879d279de4d4c633ae96f.png";